import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withLoading from '@pattern-library/with-loading';
import SimpleNavigation, {
    SimpleHeaderSkeleton,
    SimpleNavigationError
} from '@employee/simplenavigation';

const propTypes = {
    // .NET
    brandName: PropTypes.string,
    suppressNav: PropTypes.bool,
    // redux store
    menu: PropTypes.array,
    profile: PropTypes.object,
    unreadCount: PropTypes.number,
    notificationUrl: PropTypes.string,
    logoImgSrc: PropTypes.string,
    logoUrl: PropTypes.string,
    navStatus: PropTypes.string
};

const defaultProps = {
    navStatus: 'pending'
};

const SimpleNavWithLoading = withLoading(
    SimpleNavigation,
    SimpleHeaderSkeleton,
    SimpleNavigationError
);

const mapStoreToProps = store => ({
    menu: store.navigation.menu,
    profile: store.navigation.profile,
    unreadCount: store.navigation.unreadCount,
    notificationUrl: store.navigation.notificationUrl,
    logoImgSrc: store.navigation.logoImgSrc,
    logoUrl: store.navigation.logoUrl,
    navStatus: store.navigation.navStatus
});

const SimpleNavContainer = props => {
    const {
        menu,
        profile,
        unreadCount,
        notificationUrl,
        logoImgSrc,
        logoUrl,
        brandName,
        suppressNav,
        navStatus
    } = props;
    return (
        <SimpleNavWithLoading
            status={navStatus}
            brandName={brandName}
            notificationUrl={notificationUrl}
            notificationCount={unreadCount}
            suppressNav={suppressNav}
            logoUrl={logoUrl}
            logoImgSrc={logoImgSrc}
            dropdownStructure={profile}
            menuStructure={menu}
        />
    );
};

SimpleNavContainer.propTypes = propTypes;
SimpleNavContainer.defaultProps = defaultProps;
export default connect(mapStoreToProps)(SimpleNavContainer);
